(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('.tg').forEach(function (root) {
    // reveal extras
    var extras = root.querySelectorAll('.tg-close__hand');
    if (reduce || !('IntersectionObserver' in window)) { extras.forEach(function (e) { e.classList.add('is-in'); }); }
    else {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { threshold: 0.2 });
      extras.forEach(function (e) { io.observe(e); });
    }
    if (reduce) return;

    // scroll parallax: [data-tg-par="0.12"] moves against scroll
    var par = Array.prototype.slice.call(root.querySelectorAll('[data-tg-par]'));
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      par.forEach(function (el) {
        var r = el.parentNode.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var f = parseFloat(el.getAttribute('data-tg-par')) || 0.1;
        var off = (r.top + r.height / 2 - vh / 2) * -f;
        el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    if (par.length) {
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
      update();
    }

    // pointer parallax for glass beads
    root.querySelectorAll('[data-tg-tilt]').forEach(function (box) {
      var beads = box.querySelectorAll('.tg-bead');
      box.addEventListener('pointermove', function (ev) {
        var r = box.getBoundingClientRect();
        var px = ((ev.clientX - r.left) / r.width - 0.5) * 24;
        var py = ((ev.clientY - r.top) / r.height - 0.5) * 24;
        beads.forEach(function (b) { b.style.setProperty('--px', px.toFixed(1)); b.style.setProperty('--py', py.toFixed(1)); });
      });
      box.addEventListener('pointerleave', function () {
        beads.forEach(function (b) { b.style.setProperty('--px', 0); b.style.setProperty('--py', 0); });
      });
    });
  });
})();
